import classnames from 'classnames';

/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import { withRouter } from 'react-router-dom';
import TimelineIcon from './TimelineIcon';

class TimelineItem extends React.Component {
  static propTypes = {
    left: PropTypes.string,
    right: PropTypes.string,
    severity: PropTypes.string,
    isFirst: PropTypes.bool,
    isLast: PropTypes.bool,
    maintenanceId: PropTypes.number,
    incidentId: PropTypes.number
  };
  render() {
    const {
      left,
      right,
      severity,
      isFirst,
      isLast,
      maintenanceId,
      incidentId,
      history
    } = this.props;

    const impactPosition = { right, left };

    const impactClasses = classnames(
      `timeline-row-impact--${severity}`,
      'timeline-row-impact',
      {
        'timeline-row-impact': true,
        'timeline-row-impact--end': isLast
      }
    );

    // on click replaces URL with modal URl
    const click = () => {
      if (incidentId) {
        const modalPath = `/incidents/${incidentId.toString()}`;
        history.push(modalPath, { modal: true });
      }
      if (maintenanceId) {
        const modalPath = `/maintenances/${maintenanceId.toString()}`;
        history.push(modalPath, { modal: true });
      }
    };

    return (
      <div className="timeline-row-item" onClick={click}>
        <div className={impactClasses} style={impactPosition} />
        {isFirst && <TimelineIcon severity={severity} right={right} />}
      </div>
    );
  }
}

export default withRouter(TimelineItem);
